import { render, staticRenderFns } from "./ReservationWaitingListItem.vue?vue&type=template&id=038b05c8&scoped=true"
import script from "./ReservationWaitingListItem.vue?vue&type=script&lang=js"
export * from "./ReservationWaitingListItem.vue?vue&type=script&lang=js"
import style0 from "./ReservationWaitingListItem.vue?vue&type=style&index=0&id=038b05c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b05c8",
  null
  
)

export default component.exports